module.exports = __webpack_public_path__ + "static/media/H_Q.347c4dc9.png";